import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getPublicCommentsDetails,
  type DemandDraftItem,
  type DemandDraftListPayload,
  getStateList,
  type StateOption,
} from "../../services/apiEndpoints";
import { getPublicUrlAPI } from "@modules/provisional-payment/services/apiEndpoints";

export const fetchPublicComments = createAsyncThunk<
  { data: DemandDraftItem[]; total: number },
  DemandDraftListPayload
>(
  "publicComments/fetchPublicComments",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await getPublicCommentsDetails(payload);
      const axiosData = res?.data;
      const inner = axiosData?.data ?? axiosData;

      const list: DemandDraftItem[] = Array.isArray(inner?.data)
        ? inner.data
        : Array.isArray(inner)
          ? (inner as DemandDraftItem[])
          : [];

      const total = Number(inner?.total ?? list.length);
      return { data: list, total };
    } catch (err: any) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export const getStateListThunk = createAsyncThunk<
  StateOption[],
  void,
  { rejectValue: string }
>("publicComments/getStateList", async (_, { rejectWithValue }) => {
  try {
    const list = await getStateList();
    return list;
  } catch (error: any) {
    return rejectWithValue(error?.response?.data || error.message);
  }
});

export const getPublicUrlThunk = createAsyncThunk(
  "file/getPublicUrl",
  async (
    {
      document_name,
      moduletype,
    }: { document_name: string; moduletype: string },
    { rejectWithValue },
  ) => {
    try {
      const response = await getPublicUrlAPI({ document_name, moduletype });

      return response.data;
    } catch (error: any) {
      return rejectWithValue("Failed to fetch file");
    }
  },
);
